import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import './PaymentLoadingModal.css'
import '../../../assets/css/modal.css'
import { dataContext } from '../../../App';
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from 'react-router-dom';
const PaymentLoadingModal = ({ showPaymentLoadingModal, setShowPaymentLoadingModal,setToggleToUpdate,toggleToUpdate,activeBottom }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);
  let navigate = useNavigate();

  function hideModalOperation() {
    setShowPaymentLoadingModal(false)
  }

  useEffect(() => {
    // Flip with a functional updater, never `setToggleToUpdate(true)`: setting
    // it to a value it already holds is a no-op, so the parent's
    // [token, toggleToUpdate] effect would not re-run and the profile would
    // never be refetched on any payment after the first one.
    const timer = setTimeout(() => {
      console.log("processing payment");
      setToggleToUpdate((prev) => !prev)
    }, 8000);
    const secondTimer = setTimeout(() => {
      // Refetch once more on the way out, in case the telco subscription was
      // still being provisioned when the 8s refresh went out.
      setToggleToUpdate((prev) => !prev)
      setShowPaymentLoadingModal(false)
      if(activeBottom === "campaign"){
        navigate("../");
      }
    }, 10000);

    return () => {
      clearTimeout(timer);
      clearTimeout(secondTimer);
    }
  }, [])


  return (
    <>
      <Modal show={showPaymentLoadingModal} centered dialogClassName="modal-dialog" contentClassName="modalContent" onHide={hideModalOperation}>
        <Modal.Header >
          <Modal.Title>Payment Processing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Spinner animation="border" className='loadingSpinner' />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default PaymentLoadingModal